// GET all licenses
export function appDataReducerLicenses(state, action) {
    const licenses = action.licenses.message.data.map((license) => ({
        id: license.id,
    }));

    return licenses;
}

// Detail of one license
export function appDataReducerLicense(state, action) {
    if (action.license !== null) {
        const licenseDetail = action.license.message.data;
        const licenseModules = licenseDetail.modules.map((module) => ({
            id: module.id,
            name: module.name,
            description: module.description,
            readOnly: module.readonly,
        })).sort((left, right) => {
            // Natural sort by module name
            return left.name.localeCompare(right.name, undefined, {
                numeric: true,
                sensitivity: 'base'
            });
        });

        const licenseAdministrations = licenseDetail.administrations.map((administration) => ({
            id: administration.id,
            name: administration.name,
            type: administration.type,
            online: administration.online,
        }));

        let licenseScheduledChanges = null;
        if (
            typeof licenseDetail.scheduled_changes != 'undefined' &&
            licenseDetail.scheduled_changes !== null &&
            licenseDetail.scheduled_changes.length > 0
        ) {
            licenseScheduledChanges = licenseDetail.scheduled_changes.map((scheduledChange) => ({
                id: scheduledChange.id,
                licenseId: scheduledChange.license_id,
                jobId: scheduledChange.job_id,
                executed: scheduledChange.executed,
                createdAt: scheduledChange.created_at,
                description: scheduledChange.description,
                childrenMax: scheduledChange.children_max,
                expiresOn: scheduledChange.expires_on,
                scheduledOn: scheduledChange.scheduled_on,
                modules: scheduledChange.modules.map((module) => ({
                    moduleId: module.id,
                    name: module.name,
                    description: module.description,
                    readonly: module.readonly,
                })),
            }));

            // Sort the scheduled changes on date (oldest first)
            licenseScheduledChanges.sort((dateA, dateB) => {
                if (dateA.scheduledOn < dateB.scheduledOn) {
                    return -1;
                }
                if (dateA.scheduledOn > dateB.scheduledOn) {
                    return 1;
                }

                return 0;
            });
        }

        const license = {
            noLicenseConnected: false,
            id: licenseDetail.id,
            companyId: licenseDetail.company_id,
            description: licenseDetail.description,
            expiresOn: licenseDetail.expires_on,
            readOnly: licenseDetail.readonly,
            activeChildren: licenseDetail.children_registered,
            activeChildrenTsoOnly: licenseDetail.children_registered_tso_only,
            maxChildren: licenseDetail.children_max,
            idpOrganizationId: licenseDetail.idp_organization_id,
            idpProvisionedAt: licenseDetail.idp_provisioned_at,
            modules: licenseModules,
            administrations: licenseAdministrations,
            scheduledChanges: licenseScheduledChanges,
            packageLinks: licenseDetail.package_links,
        };

        return license;
    } else {
        const license = {
            noLicenseConnected: true,
        };
        return license;
    }
}

// Detail of one license with all modules
export function appDataReducerLicensesWithAllModules(state, action) {
    const licenseDetail = action.license.message.data;

    const licenseModules = {};
    for (const module of licenseDetail.modules) {
        const transformedModule = {
            id: module.id,
            name: module.name,
            description: module.description,
            readOnly: module.readonly,
        };

        licenseModules[module.id] = transformedModule;
    }

    let licenseScheduledChanges = [];
    if (
        typeof licenseDetail.scheduled_changes != 'undefined' &&
        licenseDetail.scheduled_changes !== null &&
        licenseDetail.scheduled_changes.length > 0
    ) {
        licenseScheduledChanges = licenseDetail.scheduled_changes.map((scheduledChange) => ({
            id: scheduledChange.id,
            licenseId: scheduledChange.license_id,
            jobId: scheduledChange.job_id,
            executed: scheduledChange.executed,
            createdAt: scheduledChange.created_at,
            description: scheduledChange.description,
            childrenMax: scheduledChange.children_max,
            expiresOn: scheduledChange.expires_on,
            readOnly: scheduledChange.readonly,
            scheduledOn: scheduledChange.scheduled_on,
            modules: scheduledChange.modules.map((module) => ({
                moduleId: module.id,
                readonly: module.readonly,
            })),
        }));
    }

    const license = {
        id: licenseDetail.id,
        companyId: licenseDetail.company_id,
        description: licenseDetail.description,
        expiresOn: licenseDetail.expires_on,
        readOnly: licenseDetail.readonly,
        maxAllowedChildren: licenseDetail.children_max,
        idpOrganizationId: licenseDetail.idp_organization_id,
        idpProvisionedAt: licenseDetail.idp_provisioned_at,
        administrations: licenseDetail.administrations,
        modules: licenseModules,
        scheduledChanges: licenseScheduledChanges,
    };

    return license;
}

// New or edited license
export function appDataReducerNewEditLicense(state, action) {
    return action;
}
